import { render, staticRenderFns } from "./AddExtChnlDlg.vue?vue&type=template&id=0f2b9ec5"
import script from "./AddExtChnlDlg.vue?vue&type=script&lang=js"
export * from "./AddExtChnlDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports